import { createFileRoute } from "@tanstack/react-router";
import ImageOptimizerPage from "@/pages/ImageOptimizerPage";

export const Route = createFileRoute("/tools/image-optimizer")({
  component: ImageOptimizerPage,
});
